<script setup>
import {ref} from "vue";

defineProps({
  videoUrl: {
    required: true,
    type: String,
  },
  title: {
    type: String,
    default: () => 'Vimeo video player',
  },
  allow: {
    type: String,
    default: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
  },
  allowfullscreen: {
    type: Boolean,
    default: true,
  }
})

const loaded = ref(false);

const handleOnLoad = () => {
  loaded.value = true;
}

</script>

<template>
  <div class="tw-overflow-hidden">
    <iframe
      :hidden="!loaded"
      :src="videoUrl"
      :title="title"
      :onload="handleOnLoad"
      :allow="allow"
      allowfullscreen="allowfullscreen"
      class="tw-w-full tw-h-full tw-flex-grow"
    />
    <div
      v-if="!loaded"
      class="tw-h-full tw-w-full tw-flex bg-gray"
    >
      <svg-vue
        icon="icons/loading"
        class="tw-h-6 tw-w-6 m-auto"
      />
    </div>
  </div>
</template>